/* =========================================================
   De dónde salen los datos.

   Hasta hoy aquí había un interruptor: `VITE_DATA_SOURCE=api` elegía el
   backend real y cualquier otra cosa dejaba una maqueta con datos
   inventados. El interruptor ya no existe — la maqueta se retiró — y esto
   siempre habla con la API.

   Se conserva `MemoryDataSource` aunque naciera para la maqueta:
   `ApiDataSource` hereda de ella y es lo que da las actualizaciones
   optimistas, que un cambio se vea al instante y se deshaga solo si el
   servidor lo rechaza.
   ========================================================= */
import type { DataSource } from './DataSource';
import { ApiDataSource } from './ApiDataSource';

export const ds: DataSource = new ApiDataSource(import.meta.env.VITE_API_BASE_URL ?? '');

/** La fuente de datos como ApiDataSource. Lo usan el inicio de sesión
 *  (para hidratar) y la ventana de actualización. */
export const apiSource = (): ApiDataSource => ds as ApiDataSource;

export type { DataSource } from './DataSource';
export { MemoryDataSource } from './MemoryDataSource';
export { ApiDataSource, notasDeLaUltimaPublicacion } from './ApiDataSource';
export * from './catalogs';
export { AUTH_POLICY, userOrgIds } from '@/lib/roles';
